webpackJsonp([4],{

/***/ "./install.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_deeplink__ = __webpack_require__("./lib/deeplink.js");


Object(__WEBPACK_IMPORTED_MODULE_0__lib_deeplink__["a" /* handleOS */])();
Object(__WEBPACK_IMPORTED_MODULE_0__lib_deeplink__["b" /* handleTabs */])();

/***/ }),

/***/ "./lib/deeplink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = handleTabs;
/* harmony export (immutable) */ __webpack_exports__["a"] = handleOS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../node_modules/jquery/dist/jquery.slim.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_src_dropdown_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_src_tab_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/tab.js");




function handleTabs() {
  // show the tab of the current hash
  if (location.hash) {
    var $hashTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(location.hash);

    if ($hashTab.hasClass('nav-link')) {
      $hashTab.tab('show');
    }
  }

  // on tab change, the new one comes in the history instead
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs .nav-link').on('show.bs.tab', function (e) {
    history.replaceState(history.state, document.title, location.pathname + '#' + e.currentTarget.id);
  });
}

function handleOS() {
  if (!location.hash) {
    // shows the tab of the current OS
    [[/Windows/i, '#windows-tab'], [/Mac OS/i, '#mac-tab'], [/Linux|Ubuntu|Debian/i, '#linux-tab']].find(function (os) {
      return os[0].test(navigator.userAgent) && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(os[1]).tab('show');
    });
  }
}

/***/ })

},["./install.js"]);


// WEBPACK FOOTER //
// install.aea14b3680fe43fbff15.js